import {GetComponentDataParams, GetComponentDataResponse} from '../../shared-api'
import {createAsyncAction} from '../services/redux-toolkit'
import {updateNoEventsUrl} from './navigation'

export const getComponentData = createAsyncAction<GetComponentDataResponse, GetComponentDataParams>(
  'GET_COMPONENT_DATA',
  async (params, {dispatch, extra: {serverApi}}) => {
    const component = await serverApi.getComponentData(params)

    if (params.viewMode !== 'editor') {
      dispatch(updateNoEventsUrl())
    }

    return component
  },
)
